// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'

const lossDataForForm = ({ commonLoss, rxTotalLoss, txTotalLoss }) => ({
  commonLoss: castToString(commonLoss),
  rxTotalLoss: castToString(rxTotalLoss),
  txTotalLoss: castToString(txTotalLoss),
})

export default lossDataForForm
